import { render, staticRenderFns } from "./SpamhausCheckPopover.vue?vue&type=template&id=51180ce2"
import script from "./SpamhausCheckPopover.vue?vue&type=script&lang=js"
export * from "./SpamhausCheckPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports